import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TawkToWidget = () => {
  const location = useLocation();

  // Watch route transitions to hide on /admin routes and restore on public routes
  useEffect(() => {
    const isAdminRoute = location.pathname.startsWith('/admin');
    if (isAdminRoute) {
      if (window.Tawk_API?.hideWidget) {
        window.Tawk_API.hideWidget();
      }
    } else {
      if (window.Tawk_API?.showWidget) {
        window.Tawk_API.showWidget();
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    // Clear any existing Tawk instances
    if (window.Tawk_API) {
      window.Tawk_API.onLoad = undefined;
      window.Tawk_API = undefined;
    }
    
    // Remove any existing Tawk scripts
    const existingScripts = document.querySelectorAll('script[src*="embed.tawk.to"]');
    existingScripts.forEach(script => script.remove());

    // Do not initialize on admin routes
    if (window.location.pathname.startsWith('/admin')) {
      return;
    }

    // Initialize Tawk_API and Tawk_LoadStart
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const initTawk = () => {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://embed.tawk.to/69634475100f2f197f85875c/1jels6r98';
      script.charset = 'UTF-8';
      script.setAttribute('crossorigin', '*');
      
      script.onerror = () => {
        console.warn('Tawk.to script failed to load');
      };

      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      }
    };

    const timeoutId = setTimeout(initTawk, 1000);

    return () => {
      clearTimeout(timeoutId);
      if (window.Tawk_API && window.Tawk_API.hideWidget) {
        window.Tawk_API.hideWidget();
      }
    };
  }, []);

  return null;
};

export default TawkToWidget;